import React from 'react';
import PropTypes from 'prop-types'

const Checkbox = React.forwardRef((
  {
    onChange,
    checked,
    label,
    disabled,
    readOnly,
    ...inputProps
  }, ref) => {

  const handleChange = (e) => {
    if(typeof onChange === 'function') {
      onChange(e)
    }
  }

  return (
    <label className='form-check form-check-custom form-check-solid mb-2 mt-2'>
      <input
        className='form-check-input'
        type='checkbox'
        onChange={handleChange}
        checked={checked}
        disabled={disabled}
        readOnly={readOnly}
        ref={ref}
        {...inputProps}
      />
      { label &&
      <span className='form-check-label'>
          {label}
        </span>
      }
    </label>
  )
})

Checkbox.defaultProps = {
  onChange: () => {},
  disabled: false,
  checked: false,
}

Checkbox.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
}

Checkbox.displayName = 'Checkbox';

export default Checkbox;
